import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaptain = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_391_35682)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M10.0003 19.3332C15.155 19.3332 19.3337 15.1545 19.3337 9.99984C19.3337 4.84518 15.155 0.666504 10.0003 0.666504C4.84567 0.666504 0.666992 4.84518 0.666992 9.99984C0.666992 15.1545 4.84567 19.3332 10.0003 19.3332Z",
			fill: "#FFD73B",
			stroke: "#F3BE50"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M12.6283 13.9683C11.93 14.6073 11.0371 14.9268 9.94954 14.9268C8.60384 14.9268 7.5459 14.4951 6.77572 13.6318C6.00553 12.7643 5.62044 11.5752 5.62044 10.0645C5.62044 8.43099 6.05843 7.17204 6.93441 6.2876C7.69613 5.51742 8.6652 5.13232 9.84163 5.13232C11.4159 5.13232 12.5669 5.6486 13.2948 6.68115C13.6968 7.2609 13.9126 7.84277 13.9422 8.42676H11.9871C11.8602 7.97819 11.6973 7.63965 11.4984 7.41113C11.1429 7.00488 10.616 6.80176 9.91781 6.80176C9.20687 6.80176 8.64616 7.08952 8.23568 7.66504C7.8252 8.23633 7.61995 9.04671 7.61995 10.0962C7.61995 11.1457 7.83577 11.9328 8.26742 12.4575C8.70329 12.978 9.25553 13.2383 9.92415 13.2383C10.6097 13.2383 11.1323 13.014 11.492 12.5654C11.6909 12.3242 11.856 11.9624 11.9871 11.48H13.9232C13.7539 12.4998 13.3223 13.3293 12.6283 13.9683Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_391_35682",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgCaptain;
